module.exports = __webpack_public_path__ + "static/media/truck-ramp.cfa6886c.svg";